import { supabase } from '../config/supabaseConfig.ts';

// Tipos de agente (tabla project_types) y perfiles de evaluación (qa_profiles).
// Solo el admin escribe (RLS). Ver smooth-stats-dashboard/supabase/security/16_agent_types.sql.

export const agentTypesService = {
  async getAll() {
    const [{ data: types, error }, { data: projects }] = await Promise.all([
      supabase.from('project_types').select('*').order('id'),
      supabase.from('project').select('id, project_type'),
    ]);
    if (error) throw error;
    const usage = {};
    (projects || []).forEach((p) => { usage[p.project_type] = (usage[p.project_type] || 0) + 1; });
    return (types || []).map((t) => ({ ...t, projects: usage[t.id] || 0 }));
  },

  async save(type) {
    const row = {
      name: type.name.trim(),
      description: type.description?.trim() || null,
      qa_profile: type.qa_profile || null,
      default_modules: type.default_modules || null,
    };
    const query = type.id
      ? supabase.from('project_types').update(row).eq('id', type.id).select('*').single()
      : supabase.from('project_types').insert(row).select('*').single();
    const { data, error } = await query;
    if (error) throw error;
    return data;
  },
};

export const qaProfilesService = {
  async getAll() {
    const { data, error } = await supabase.from('qa_profiles').select('*').order('name');
    if (error) throw error;
    return data || [];
  },

  async save(profile) {
    const { data, error } = await supabase
      .from('qa_profiles')
      .upsert({
        key: profile.key,
        name: profile.name.trim(),
        objective: profile.objective.trim(),
        interest_label: profile.interest_label.trim(),
        stages: profile.stages,
        loss_reasons: profile.loss_reasons,
        updated_at: new Date().toISOString(),
      }, { onConflict: 'key' })
      .select('*')
      .single();
    if (error) throw error;
    return data;
  },
};

/** Clave legible y única a partir de un nombre ("Venta de cursos" → "venta_de_cursos"). */
export const slugKey = (text, taken = []) => {
  const base = (text || 'perfil')
    .toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 34) || 'perfil';
  let key = base;
  let n = 2;
  while (taken.includes(key)) key = `${base}_${n++}`;
  return key;
};
